import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { deepClone } from './utils'
import { getOAuth2RedirectUrl, getConfigData } from '@/api/other/happyNewYear'
import Cookies from 'js-cookie'
import wx from 'weixin-js-sdk'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/404'] // no redirect whitelist
const specialModules = ['happy-new-year']
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()

  if (specialModules.includes(to.path.split('/')[1])) {
    // 特殊模块，不需要任何校验 如红包模块
    // 微信授权
    await getWxAuthorize(to, from, next)
    return
  }

  // set page title
  document.title = getPageTitle(to.meta.title, to.path)

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else if (to.path === '/dms/home/bi') {
      const toPathModel = to.path.split('/')[1]
      // 如果从登录页面或者其他模块跳转，而Home下的路由只有BI的情况，不进行跳转
      if (from.path === '/login' || store.getters.last_permission_routesType !== 'DMS') {
        let nextPath = '/user/info' // 防止所有权限都没有的情况，跳转到个人中心
        for (let i = 0; i < store.getters.permission_uri.length; i++) {
          const uri = store.getters.permission_uri[i]
          const uriSplit = uri.split('/')
          if (!uri.includes('home') && uriSplit.length > 3 && toPathModel === uriSplit[1]) {
            nextPath = uri
            break
          }
        }
        store.dispatch('permission/changeLastRouterType', 'DMS')
        next(nextPath)
      } else {
        const url = `${location.origin}/user/loginBI`
        window.open(url)
      }
      NProgress.done()
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasUID = store.getters.uid && store.getters.uid !== 0
      if (hasUID) {
        next()
      } else {
        try {
        // get user info
          const data = await store.dispatch('user/getInfo')
          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', data)

          // 刷新后添加动态路由
          let orderRouter = localStorage.getItem('orderRouter')
          if (orderRouter) {
            orderRouter = JSON.parse(orderRouter)
            if (store.getters.token === orderRouter.token) {
              accessRoutes.forEach((element) => {
                if (element.path === orderRouter.fullPath) {
                  let router = {}
                  element.children.forEach((item) => {
                    if (item.path === orderRouter.path.replace(/\d/g, '') && item.name === orderRouter.name.replace(/\d/g, '')) {
                      router = deepClone(item)
                      router.name = orderRouter.name
                      router.path = orderRouter.path
                      router.meta.title = orderRouter.title
                      router.hidden = true
                      element.children.push(router)
                    }
                  })
                }
              })
            } else {
              localStorage.removeItem('orderRouter')
            }
          }
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record

          // 跳转回到登录前的页面
          if (localStorage.getItem('fromRuter')) {
            next(localStorage.getItem('fromRuter'))
            localStorage.removeItem('fromRuter')
          } else {
            next({ ...to, replace: true })
          }
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly

      // 保存是从哪个页面跳转到登录页面的
      if (to.path === '/login' && from.fullPath !== '/') {
        localStorage.setItem('fromRuter', from.fullPath)
      }
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

const getWxAuthorize = async(to, from, next) => {
  // 微信授权能获取openId
  if (process.env.NODE_ENV !== 'production') {
  // 测试环境，手动设置openId
    Cookies.set('openid', 'oOsnf6W-q7XkPgThQZVIctt5a-RA')
  }

  if (Cookies.get('openid')) {
    console.log('openId存在', Cookies.get('openid'))

    getConfigData({
      url: window.location.href.split('#')[0]
    }).then(res => {
      wx.config({
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
      })

      wx.ready(() => {
        console.log('config完成')
      })
      wx.error((res) => {
        console.log('config失败')
        console.log(res)
      })
    })

    next()
    NProgress.done()
  } else {
    if (to.query.openid) {
      // 微信授权验签
      if (to.query.state) {
        if (to.query.state !== Cookies.get('oauth2-state')) {
          Message.error('验签失败')
          return false
        }

        Cookies.remove('oauth2-state')
        // 添加openId
        Cookies.set('openid', to.query.openid)
        const query = to.query
        // 去掉信息不能显示在url上面
        delete query['openid']
        delete query['state']
        delete query['is_snapshot_user']
        delete query['scope']

        console.log('成功到这里了')

        router.push({
          path: to.path,
          query
        })
      }

      next()
      NProgress.done()
    } else {
      const path = location.origin + '/#' + to.path
      await getOAuth2RedirectUrl({
        path: path
      }).then(res => {
        window.location.href = res.data
      }).finally(() => {
        NProgress.done()
      })
    }
  }
}
